export const linkColorSubTitle = [
    {
        text: "Use the ",
        code: '.alert-link'
    },
    {
        text: ' utility class to quickly provide matching colored links within any alert'
    }
];

export const outlineAlertSubTitle = [
    {
        text: "Use the",
        code: ' .border-* '
    },
    {
        text: 'utility class to quickly provide matching border and border-width within any alert.'
    }
];

export const alertWithIconSubTitle = [
    {
        text: "Use the ",
        code: '.dismiss-text'
    },
    {
        text: ' class to add dismiss text instead of icon'
    }
];

export const dismissAlertSubTitle = [
    {
        text: "Use the ",
        code: '.alert-dismissible'
    },
    {
        text: ' utility class to quickly remove the alerts.'
    }
];

export const liveAlertSubTitle = [
    {
        text: "Click the button below to show an alert, then dismiss it with the built-in close button."
    }
];

export const leftBorderAlertSubTitle = [
    {
        text: "Use the ",
        code: '.border-left-wrapper '
    },
    {
        text: 'to change border-left radius.'
    }
];

export const additionalAlertSubTitle = [
    {
        text: "Use the ",
        code: '.alert'
    },
    {
        text: ' utility class to quickly provide additional content within any alerts.'
    }
]

export const alertColorData = [
    {
        data: [
            {
                text: 'Primary Alert',
                class: 'primary',
            },
            {
                text: 'Secondary Alert',
                class: 'secondary',
            },
            {
                text: 'Info Alert',
                class: 'info',
            },
            {
                text: 'Success Alert',
                class: 'success',
            }
        ]
    },
    {
        data: [
            {
                text: 'Warning Alert',
                class: 'warning',
            },
            {
                text: 'Danger Alert',
                class: 'danger',
            },
            {
                text: 'Light Alert',
                class: 'light',
            },
            {
                text: 'Dark Alert',
                class: 'dark',
            }
        ]
    }
]

export const alertLightColorData = [
    {
        data: [
            {
                text: 'Primary Light Alert',
                class: 'primary',
                textClass: 'primary',
            },
            {
                text: 'Secondary Light Alert',
                class: 'secondary',
                textClass: 'secondary',
            },
            {
                text: 'Success Light Alert',
                class: 'success',
                textClass: 'success',
            },
            {
                text: 'Info Light Alert',
                class: 'info',
                textClass: 'info',
            }
        ]
    },
    {
        data: [
            {
                text: 'Warning Light Alert',
                class: 'warning',
                textClass: 'warning',
            },
            {
                text: 'Danger Light Alert',
                class: 'danger',
                textClass: 'danger',
            },
            {
                text: 'Light Light Alert',
                class: 'light',
                textClass: 'dark',
            },
            {
                text: 'Dark Light Alert',
                class: 'dark',
                textClass: 'dark',
            }
        ]
    }
]

export const additionalAlertData = [
    {
        class: 'primary',
        head: 'Please! Check your notifications',
        text: 'The duty of notification is imposed upon the head of the family, and also upon the medical practitioner who may be in attendance on the patient.',
        subtext: 'The emergency notification system is free and is available in all 50 states.',
    },
    {
        class: 'secondary',
        head: 'Something went wrong! Please, chrome update.',
        text: 'The duty of notification is imposed upon the head of the family, and also upon the medical practitioner who may be in attendance on the patient.',
        subtext: 'Whenever you need to, be sure to use margin utilities to keep things nice and tidy.',
    },
    {
        class: 'success',
        head: 'Please! Hidden cameras were not installed.',
        text: 'Due to increasingly accessible technology, hidden cameras have grown in popularity among regular people in recent years.',
        subtext: 'Consider moving clocks and plush animals from your area if you think they may be concealing cameras because they are both portable items.',
    }
]